import { useEffect, useState } from "react";
import { useAuth } from "./AuthProvider.js";
import { isSessionEnded } from "./refreshSession.js";

// Session restore at startup (F5 or a new tab: no access token, maybe a valid refresh cookie).
// Never throws: sessionEnded = the server rejected the refresh and useRefreshToken already ended
// the session (redirect to /login in progress).
export const restoreSession = async (refresh) => {
  try {
    await refresh();
    return { sessionEnded: false };
  } catch (err) {
    // solo lo status: l'errore axios completo contiene l'header Authorization
    console.error("refresh failed", err?.response?.status);
    return { sessionEnded: !!err?.sessionEnded };
  }
};

// Renders the fallback until the session is restored, then the children (put RequireAuth inside).
// refresh: the app's useRefreshToken callback (single-flight).
const SessionGate = ({ refresh, fallback = null, children }) => {
  const { auth } = useAuth();
  const [isLoading, setIsLoading] = useState(!auth?.accessToken);

  useEffect(() => {
    if (auth?.accessToken) return;
    // dopo una chiusura di sessione il refresh e' stato rifiutato e il redirect a /login e' gia' partito
    if (isSessionEnded()) return;
    let isMounted = true;
    restoreSession(refresh).then(() => {
      if (isMounted) setIsLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- startup only

  return isLoading ? fallback : children;
};

export default SessionGate;
